import React from 'react';
import { cn } from '@/lib/utils';
import { TrendingFilter as TrendingFilterType } from '@/hooks/useTrendingData';

interface TrendingFilterProps {
  selectedFilter: TrendingFilterType;
  onFilterChange: (filter: TrendingFilterType) => void;
  className?: string;
}

const FILTER_OPTIONS: { value: TrendingFilterType; label: string; description: string }[] = [
  {
    value: 'new',
    label: 'New',
    description: 'Latest AI solutions added'
  },
  {
    value: 'trending-week',
    label: 'Trending - This Week',
    description: 'Most clicked solutions this week'
  },
  {
    value: 'trending-month',
    label: 'Trending - This Month',
    description: 'Most clicked solutions this month'
  }
];

const TrendingFilter: React.FC<TrendingFilterProps> = ({
  selectedFilter,
  onFilterChange,
  className
}) => {
  return (
    <div className={cn("flex flex-wrap gap-2", className)}>
      {FILTER_OPTIONS.map((option) => (
        <button
          key={option.value}
          onClick={() => onFilterChange(option.value)}
          className={cn(
            "px-4 py-2 rounded-lg text-sm font-medium transition-all duration-200",
            "border border-border/50 hover:border-primary/50",
            "focus:outline-none focus:ring-2 focus:ring-primary/20",
            selectedFilter === option.value
              ? "bg-primary text-primary-foreground border-primary shadow-sm"
              : "bg-background hover:bg-secondary/50 text-foreground"
          )}
          title={option.description}
        >
          {option.label}
        </button>
      ))}
    </div>
  );
};

export default TrendingFilter; 